import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { ICategoryInput } from "@/interfaces/product.category.interfaces";
import categoryService from "@/services/category.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateCategoryProps = {
  formData: ICategoryInput;
} & RequestsProps;

export type UseCreateCategoryReturn = {
  create: (props: CreateCategoryProps) => Promise<void>;
} & UseLoadingReturn;

const useCreateCategory = (): UseCreateCategoryReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<ICategoryInput>({
    operation: (formData) => categoryService.create(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateCategory;
